import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5002/api';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authService = {
  login: async (username, password) => {
    const response = await api.post('/auth/login', { username, password });
    return response.data;
  },

  requestOtp: async (username) => {
    const response = await api.post('/auth/request-otp', { username });
    return response.data;
  },

  loginWithOtp: async (username, code) => {
    const response = await api.post('/auth/login-otp', { username, code });
    return response.data;
  },

  updateProfile: async (email) => {
    const response = await api.put('/auth/profile', { email });
    return response.data;
  },

  getCurrentUser: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },

  updateOpenProjectConfig: async (url, apiKey, telegramBotToken, telegramChatId) => {
    const response = await api.post('/auth/openproject-config', { 
      url, 
      apiKey, 
      telegramBotToken, 
      telegramChatId 
    });
    return response.data;
  },

  getOpenProjectConfig: async () => {
    const response = await api.get('/auth/openproject-config');
    return response.data;
  },

  testTelegramConnection: async (telegramBotToken, telegramChatId) => {
    const response = await api.post('/auth/test-telegram', {
      telegramBotToken,
      telegramChatId
    });
    return response.data;
  },

  changePassword: async (currentPassword, newPassword) => {
    const response = await api.post('/auth/change-password', {
      currentPassword,
      newPassword
    });
    return response.data;
  },

  createAdmin: async (username, password) => {
    const response = await api.post('/auth/create-admin', {
      username,
      password
    });
    return response.data;
  },

  logout: async () => {
    const response = await api.post('/auth/logout');
    return response.data;
  },

  getUsers: async () => {
    const response = await api.get('/auth/users');
    return response.data;
  },

  deleteUser: async (userId) => {
    const response = await api.delete(`/auth/users/${userId}`);
    return response.data;
  }
};

export default api;
